export const TASK_ON_BEHALF_OF_TYPE = {
    OWNER: 'owner',
    RELATED_TO: 'relatedTo',
};
